import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import { Grandpa } from "../actors/characters/grandpa";

import { Hive } from "../actors/hive";
import { hiveState, inventoryState } from "../state/stateManager";
import { goToScene } from "../main";
import HtmlHud, { createHtmlHud } from "../ui/htmlHud";
import { createGainedItem, getZeal, sendAlert } from "../utils";
import AddHiveMenu from "../ui/addHiveMenu";
import HoneyStand from "../actors/honeyStand";
import Girl from "../actors/characters/girl";
import InventoryHUD from "../ui/inventory";
import Swarm from "../actors/swarm";
export class Home extends ex.Scene {
  constructor() {
    super();
    const player = new Player(100, 200, () => {});
    this.player = player;

    this.player.z = 4;
    const grandpa = new Grandpa(75, 150);
    this.grandpa = grandpa;
    this.honeyStand = new HoneyStand({ x: 24 * 16 - 5, y: 23 * 16 + 8 }, this);
    this.showingInventory = false;
    this.addingHive = false;
    console.log("constructor setting activeHive to null");
    this.activeHive = null;
    this.swarmCheckTimer;
  }
  onInitialize(engine) {
    this.engine = engine;
    Resources.TiledMap.addToScene(this);

    this.add(this.player);
    this.add(this.honeyStand);
    this.honeyStand.z = 10;
    this.camera.strategy.lockToActor(this.player);
    // this.swarm = new Swarm({ x: 32 * 16, y: 17 * 16 });
    // this.add(this.swarm);

    this.camera.zoom = 1.5;
    const map_bounds = ex.BoundingBox.fromDimension(
      Resources.TiledMap.map.width * Resources.TiledMap.map.tilewidth + 10,
      Resources.TiledMap.map.height * Resources.TiledMap.map.tileheight + 10,
      ex.Vector.Zero,
      Resources.TiledMap.pos
    );
    this.camera.strategy.limitCameraBounds(map_bounds);

    this.door = new ex.Trigger({
      pos: new ex.Vector(8 * 16, 10 * 16 + 8),
      width: 32,
      height: 16,
      visible: true,
      target: this.player,
      action: () => {
        console.log("collided with trigger");
        goToScene("house");
      },
    });
    this.honeyHouseDoor = new ex.Trigger({
      pos: new ex.Vector(12.5 * 16, 10 * 16 + 8),
      width: 16,
      height: 16,
      visible: true,
      target: this.player,
      action: () => {
        console.log("collided with honeyHouse");
        goToScene("honeyHouse");
      },
    });
    this.back40Door = new ex.Trigger({
      pos: new ex.Vector(15 * 16, 10),
      width: 32,
      height: 16,
      visible: true,
      target: this.player,
      action: () => {
        console.log("collided with trigger");
        goToScene("back40");
      },
    });
    this.crossroads = new ex.Trigger({
      pos: new ex.Vector(21 * 16, 24 * 16),
      width: 32,
      height: 16,
      visible: true,
      target: this.player,
      action: () => {
        console.log("collided with trigger");
        this.honeyStand.destroyNotification();
        goToScene("crossroads", { x: 19 * 16, y: 2 * 16, direction: "down" });
      },
    });
    // this.girl = new Girl({ x: 300, y: 150 });
    // this.add(this.girl);
    this.add(this.crossroads);
    this.add(this.back40Door);
    this.add(this.honeyHouseDoor);
    this.add(this.door);
    // this.player.on("collisionstart", (e) => {
    //   console.log("player collided: ", e);
    //   if (e.other.hiveStats) {
    //     console.log("collided with hive");
    //     this.activeHive = e.other.hiveStats;
    //   }
    // });
    // this.player.on("collisionend", () => {
    //   console.log("collision hive ended");
    //   this.activeHive = null;
    // });
  }
  onDeactivate() {
    this.killHives();
    this.hud.cancelHud();
  }
  killHives() {
    this.hiveActors.forEach((h) => {
      h.kill();
    });
  }
  setActive(hive) {
    console.log("inside setActive: ", hive);
    this.activeHive = hive;
    console.log("active: ", this);
  }
  setCollision(ans) {
    console.log("inside setCollision: ", ans);
    if (ans == "honeyStand") {
      this.honeyStandCollision = true;
    } else {
      this.honeyStandCollision = false;
    }
    console.log("setCollision: ", this.honeyStandCollision);
  }
  onActivate(data) {
    if (this.hiveActors) {
      this.killHives();
    }

    console.log("activating home: ", data);
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    Resources.BeeSounds.stop();
    Resources.AppleCider.stop();
    Resources.AppleCider.play(0.1);
    Resources.AppleCider.loop = true;
    this.addingHive = false;
    // this.add(new Hud(game));
    this.hud = new HtmlHud();

    this.hives = hiveState.getHives();
    console.log("getting ready to add hives: ", this.hives);
    this.setHives();
    this.swarmCheck();
    this.startSwarmTimer();
  }
  swarmCheck() {
    console.log("inside swarmCheck");
    let hives = hiveState.getHives();
    hives.forEach((hi) => {
      if (hi.notes !== undefined && hi.notes !== null && hi.notes.length > 0) {
        //have swarm
        console.log("have swarm swarmCheck");
        if (hi.position.yard == "home") {
          //sendSwarm
          console.log("sending swarm: swarmCheck");
          hi.notes.splice(0, 1);
          this.hiveActors.forEach((ha) => {
            if (ha.birth == hi.birth) {
              console.log("calling swarm from hiveactors swarmCheck");
              sendAlert(`${hi.id} Swarmed!`);
              ha.swarm();
            }
          });
        }
      }
    });
  }
  startSwarmTimer() {
    this.swarmCheckTimer = setInterval(() => {
      this.swarmCheck();
    }, 10000);
  }
  stopSwarmTimer() {
    clearInterval(this.swarmCheckTimer);
  }
  setHives() {
    this.hiveActors = [];
    for (let i = 0; i < this.hives.length; i++) {
      if (this.hives[i].position.yard == "home") {
        let ho = new Hive(
          this.hives[i].position.x,
          this.hives[i].position.y,
          this.hives[i],
          this
        );
        this.add(ho);
        this.hiveActors.push(ho);
      }
    }
  }
  removeActive() {
    console.log("removing activeHive should not open: ", this.activeHive);
    this.activeHive = null;
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
      console.log("should open hiveMenu: ", this.activeHive);
      if (this.activeHive !== null && !this.addingHive) {
        //check zeal
        if (getZeal()) {
          let indication = document.getElementById("hive-indication");
          indication.classList.remove("active");
          indication.style.display = "none";
          this.hud.cancelHud();
          //get updated hivestats before sending to hivemenu
          let hives = hiveState.getHives();
          hives.forEach((hi) => {
            if (hi.birth === this.activeHive.birth) {
              this.activeHive = hi;
            }
          });
          goToScene("hiveMenu", this.activeHive);
        } else {
          Resources.Error.play();
          sendAlert("Over Sting Tolerance. No Zeal.");
        }
      } else {
        //add hive here
        if (this.honeyStandCollision) {
          this.honeyStand.destroyNotification();
          this.honeyStandCollision = false;
          this.hud.cancelHud();
          goToScene("honeyStand");
        } else {
          this.addingHive = true;
          this.addHiveMenu = new AddHiveMenu();
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Enter)) {
      if (this.addingHive) {
        //add hive to this spot
        let xSpot = (this.player.pos.x + 8) / 16;
        let ySpot = (this.player.pos.y + 8) / 16;
        console.log(
          "addHive to this spot: x: ",
          xSpot,
          " y: ",
          ySpot,
          " playerPos: ",
          this.player.pos
        );
        goToScene("addHive", { x: xSpot, y: ySpot, yard: "home" });
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.F)) {
      if (this.activeHive !== null && !this.addingHive) {
        const inventory = inventoryState.getInventory();
        console.log("feeding");

        if (inventory.sugar >= 2) {
          console.log("hive from state : ", this.activeHive);
          let foodFrames = this.activeHive.foodFrames;
          foodFrames.count = foodFrames.count + 0.2;
          let hives = hiveState.getHives();
          hives.forEach((hive, i) => {
            if (hive.birth == this.activeHive.birth) {
              console.log("got hive");
              hive.foodFrames = foodFrames;
            }
          });
          inventory.sugar = inventory.sugar - 2;
          inventoryState.setInventory(inventory);
          hiveState.setHives(hives);
          Resources.Feed.play();
          sendAlert("Fed 1lb of Syrup!");
        } else {
          sendAlert("Not Enough Supply", () => {});
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.X)) {
      if (this.addingHive) {
        this.addHiveMenu.destroy();
        this.addingHive = false;
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.S)) {
      if (this.activeHive !== null && !this.addingHive) {
        console.log("setting lastSmoked");
        let hives = hiveState.getHives();
        hives.forEach((hi, i) => {
          if (hi.birth === this.activeHive.birth) {
            hi.lastSmoked = new Date().getTime();
          }
        });
        hiveState.setHives(hives);
      }
      switch (this.player.lastDir) {
        case "up":
          this.player.doAnim("up-smoke");
          break;
        case "down":
          this.player.doAnim("down-smoke");
          break;
        case "left":
          this.player.doAnim("left-smoke");
          break;
        case "right":
          this.player.doAnim("right-smoke");
          break;
        default:
          break;
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.I)) {
      if (!this.showingInventory) {
        this.showingInventory = true;
        this.inventoryUI = new InventoryHUD("home");
      } else {
        this.showingInventory = false;
        this.inventoryUI.destroy();
      }
    }
  }

  // update() {
  //   if (this.engine.input.keyboard.wasPressed(ex.Keys.Esc)) {
  //     console.log("should open hiveMenu");
  //     goToScene("startMenu");
  //   }
  // }
  onDeactivate() {
    Resources.AppleCider.stop();
    this.hud.cancelHud();
    if (this.swarmCheckTimer) {
      this.stopSwarmTimer();
    }
  }
}
